import React, { useState, useEffect } from 'react';

const QuizRegistration = () => {
  // External deployed form link - Replace with your actual link
  const registrationFormUrl = "https://your-deployed-form-link.com";

  // State to manage real-time countdown
  const [timeLeft, setTimeLeft] = useState({
    days: 9,
    hrs: 15,
    mins: 2,
    secs: 55
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { days, hrs, mins, secs } = prev;

        if (secs > 0) {
          secs--;
        } else {
          secs = 59;
          if (mins > 0) {
            mins--;
          } else {
            mins = 59;
            if (hrs > 0) {
              hrs--;
            } else {
              hrs = 23;
              if (days > 0) days--;
            }
          }
        }
        return { days, hrs, mins, secs };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleRegister = () => {
    window.open(registrationFormUrl, "_blank");
  };

  // Helper to format numbers to 2 digits
  const formatTime = (num) => num.toString().padStart(2, '0');

  return (
    <main className="pt-[140px] pb-20 bg-slate-50 dark:bg-slate-950 min-h-screen">
      <div className="max-w-[1200px] mx-auto px-5 text-center">
        
        <div className="mb-10 animate-in fade-in slide-in-from-top-4 duration-700">
          <span className="bg-blue-50 dark:bg-blue-900/30 text-primary text-[10px] font-black px-4 py-1.5 rounded-full uppercase tracking-widest border border-blue-100 dark:border-blue-800">
            Monthly Event
          </span>
          <h1 className="text-4xl md:text-6xl font-black text-slate-900 dark:text-white mt-6 mb-4">
            Senvra AI <span className="text-primary">Quiz Registration</span>
          </h1>
        </div>

        {/* Registration Card */}
        <div className="max-w-3xl mx-auto bg-white dark:bg-slate-900 rounded-[40px] shadow-[0_30px_60px_rgba(0,0,0,0.05)] border border-slate-100 dark:border-slate-800 p-8 md:p-16 relative overflow-hidden">
          
          <div className="flex justify-between items-start mb-10">
            <div className="w-16 h-16 bg-blue-50 dark:bg-blue-900/20 rounded-2xl flex items-center justify-center border border-blue-100 dark:border-blue-800">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
            </div>
            <span className="bg-emerald-50 dark:bg-emerald-900/20 text-emerald-500 text-[11px] font-black px-4 py-1.5 rounded-full border border-emerald-100 dark:border-emerald-800">
              Next: 5th Mar
            </span>
          </div>

          <div className="text-left mb-12">
            <h2 className="text-3xl font-black text-slate-900 dark:text-white mb-4 tracking-tight">Register for Next Quiz</h2>
            <p className="text-slate-500 dark:text-slate-400 font-medium leading-relaxed">
              Don't miss out! Registration is open for the upcoming tech quiz. Topics include Web Dev, AI, and more. Secure your spot now to test your knowledge and win exciting badges.
            </p>
          </div>

          {/* Countdown Section - Matches image_c6acfc.png */}
          <div className="mb-12">
            <div className="flex items-center gap-2 text-[11px] font-black text-slate-400 uppercase tracking-widest mb-6">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
              Registration Ends In
            </div>
            
            <div className="grid grid-cols-4 gap-3 md:gap-6">
              {[
                { label: 'DAYS', value: formatTime(timeLeft.days) },
                { label: 'HRS', value: formatTime(timeLeft.hrs) },
                { label: 'MINS', value: formatTime(timeLeft.mins) },
                { label: 'SECS', value: formatTime(timeLeft.secs) }
              ].map((unit, i) => (
                <div key={i} className="bg-slate-50 dark:bg-slate-800/50 rounded-2xl p-4 md:p-6 border border-slate-100 dark:border-slate-800 flex flex-col items-center">
                  <span className="text-2xl md:text-4xl font-black text-primary mb-1">{unit.value}</span>
                  <span className="text-[9px] md:text-[10px] font-black text-slate-400 uppercase tracking-widest">{unit.label}</span>
                </div>
              ))}
            </div>
          </div>

          <button 
            onClick={handleRegister}
            className="w-full py-5 bg-primary hover:bg-primary/90 text-white rounded-2xl font-black text-lg flex items-center justify-center gap-3 transition-all shadow-lg shadow-primary/20 active:scale-[0.98]"
          >
            Register Now <span>&rarr;</span>
          </button>
          
          <p className="mt-6 text-[10px] text-slate-400 font-medium italic">
            * Registration closes 24 hours before the event.
          </p>
        </div>
      </div>
    </main>
  );
};

export default QuizRegistration;